import { HealthConditionContainer } from './HealthConditionsContainer';
import {  useParams } from 'react-router-dom';
import { useGetHealthConnectionDetail } from '@viome/viome-base/src/usecase/Health/HealthQuery';

export const HealthConditionsPage = () => {
  const { condition: conditionName } = useParams();
  const { data: healthConnectionDetail = {}, isLoading } = useGetHealthConnectionDetail(conditionName || '');

  return (
    <div className="dark bg-black h-full w-full">
      <HealthConditionContainer condition={healthConnectionDetail} isLoading={isLoading} />
    </div>
  );
};
